import request from '@/plugins/axios'

//创建word格式文稿
export function save(params) {
  return request({
    url: '/document/save',
    method: 'post',
    params
  })
}
//创建html格式文稿
export function create(data) {
  return request({
    url: '/document/create',
    method: 'post',
    data
  })
}

//文稿列表
export function selectList(params) {
  return request({
    url: '/document/selectList',
    method: 'get',
    params
  })
}

//查询单个文稿详情
export function selectInfo(params) {
  return request({
    url: '/document/selectInfo',
    method: 'get',
    params
  })
}


//软删除文稿
export function deleteDocument(params) {
  return request({
    url: '/document/softDelete',
    method: 'post',
    params
  })
}

//删除文稿
export function deleteHard(params) {
  return request({
    url: '/document/delete',
    method: 'post',
    params
  })
}

//恢复文稿
export function recover(params) {
  return request({
    url: '/document/recover',
    method: 'post',
    params
  })
}



//编辑内容
export function updateContent(data) {
  return request({
    url: '/document/updateContent',
    method: 'post',
    data
  })
}
//编辑内容
export function updateDocument(data) {
  return request({
    url: '/document/updateDocument',
    method: 'post',
    data
  })
}



//修改标题
export function updateTitle(params) {
  return request({
    url: '/document/updateTitle',
    method: 'post',
    params
  })
}
